import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { Certificate1, Certificate2, Certificate3 } from "src/assets";
import { Box, CardMedia, Stack } from "@mui/material";

interface CertificateSectionProps {
  showHeadline?: boolean;
  smallerBadges?: boolean;
}

const CertificateSection = ({
  showHeadline = true,
  smallerBadges = false,
}: CertificateSectionProps) => {
  const { t } = useTranslation();

  const gapMd = smallerBadges ? "16px" : "30px";
  const mlContainerMd = smallerBadges ? "24px" : "30px";
  const heightMd = smallerBadges ? "130px" : "175px";
  const heightThirdMd = smallerBadges ? "164px" : "220px";
  const mlThirdMd = smallerBadges ? "-45px" : "-60px";

  return (
    <>
      <Stack gap={2} width="100%">
        {showHeadline && (
          <Stack
            sx={{
              maxWidth: { sm: "300px" },
              textAlign: "center",
              mx: "auto",
            }}
          >
            <Text
              text={t("common.CertificateSection.title")}
              sx={{
                fontWeight: 600,
                lineHeight: "21px",
              }}
            />
          </Stack>
        )}

        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            flexDirection: "row",
            gap: "16px",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            ml: 3.5,
          }}
        >
          <Box sx={{ height: "80px" }}>
            <CardMedia
              alt="Zertifikat1"
              component="img"
              image={Certificate1}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box sx={{ height: "80px" }}>
            <CardMedia
              alt="Zertifikat2"
              component="img"
              image={Certificate2}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box sx={{ height: "100px" }}>
            <CardMedia
              alt="Zertifikat3"
              component="img"
              image={Certificate3}
              sx={{
                ml: -7,
                height: "100%",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
            gap: { sm: "16px", md: gapMd },
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            ml: { md: mlContainerMd },
          }}
        >
          <Box sx={{ height: { sm: "90px", md: heightMd } }}>
            <CardMedia
              alt="Zertifikat1"
              component="img"
              image={Certificate1}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box sx={{ height: { sm: "90px", md: heightMd } }}>
            <CardMedia
              alt="Zertifikat2"
              component="img"
              image={Certificate2}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box
            sx={{
              height: { sm: "115px", md: heightThirdMd },
              ml: { sm: "-14px", md: mlThirdMd },
            }}
          >
            <CardMedia
              alt="Zertifikat3"
              component="img"
              image={Certificate3}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
        </Box>
      </Stack>
    </>
  );
};

export default CertificateSection;
